import { MaterialCommunityIcons } from "@expo/vector-icons";
import { HStack, Image, Link, Text, VStack } from "native-base";
import React from "react";

import IfeiraLogo from "@/assets/icons/secondary_icon.png";
import RoundedIcon from "@/components/atoms/RoundedIcon";
import { POLICY_URL, TERMS_URL } from "@/config/constants";

const Footer = () => {
  return (
    <VStack position="absolute" top={"100%"} w="full" bgColor="light.200" mt="12" p="10" px="1/4">
      <HStack w="100%" justifyContent="space-between">
        <VStack alignItems="center">
          <Image source={IfeiraLogo} resizeMode="contain" w="200px" h="100px" alt="ifeira logo" />
          <HStack justifyContent="space-between" mt="1/6">
            <Link href="https://www.facebook.com/ifeiraoficial" p="2" isExternal>
              <RoundedIcon icon={<MaterialCommunityIcons name="facebook" />} boxSize="48px" />
            </Link>
            <Link href="https://www.instagram.com/ifeira_oficial/" p="2" isExternal>
              <RoundedIcon icon={<MaterialCommunityIcons name="instagram" />} boxSize="48px" />
            </Link>
            <Link href="https://www.linkedin.com/company/ifeira" p="2" isExternal>
              <RoundedIcon icon={<MaterialCommunityIcons name="linkedin" />} boxSize="48px" />
            </Link>
          </HStack>
        </VStack>
        <HStack w="40%" justifyContent="space-between">
          <VStack alignItems="center">
            <Text color="text.600" fontSize="lg" textTransform="uppercase" bold pb="4">
              Empresa
            </Text>
            <Link
              href="https://ifeiraoficial.com.br"
              isExternal
              p="2"
              _text={{ fontSize: "lg", color: "primary.600", fontWeight: "bold" }}>
              Sobre nós
            </Link>
            <Link
              href="/central-de-ajuda"
              p="2"
              _text={{ fontSize: "lg", color: "primary.600", fontWeight: "bold" }}>
              Ajuda
            </Link>
          </VStack>
          <VStack alignItems="center">
            <Text color="text.600" fontSize="lg" textTransform="uppercase" bold pb="4">
              Link úteis
            </Text>
            <Link
              href="https://ifeiraoficial.com.br"
              isExternal
              p="2"
              _text={{ fontSize: "lg", color: "primary.600", fontWeight: "bold" }}>
              Blog iFeira
            </Link>
            <Link
              href="https://ifeiraoficial.com.br/#contato"
              isExternal
              p="2"
              _text={{ fontSize: "lg", color: "primary.600", fontWeight: "bold" }}>
              Parceiros
            </Link>
          </VStack>
        </HStack>
      </HStack>
      <HStack alignItems="center" justifyContent="space-between" pt="20">
        <HStack>
          <Link
            href={TERMS_URL}
            isExternal
            p="2"
            _text={{ fontSize: "lg", color: "primary.600", fontWeight: "bold" }}>
            Termos de uso
          </Link>
          <Link
            href={POLICY_URL}
            isExternal
            p="2"
            _text={{ fontSize: "lg", color: "primary.600", fontWeight: "bold" }}>
            Politica de privacidade
          </Link>
          <Link
            href="https://ifeiraoficial.com.br"
            isExternal
            p="2"
            _text={{ fontSize: "lg", color: "primary.600", fontWeight: "bold" }}>
            Cookies
          </Link>
        </HStack>
        <Text color="text.600" fontSize="lg" bold>
          2023 iFeira - VG Softwares. Todos os direitos reservados
        </Text>
      </HStack>
    </VStack>
  );
};

export default Footer;
